/* Enhances decorative link arrows, including translated page/article content.
   Destinations, text labels, form controls and navigation controls are unchanged. */
(() => {
  const template = document.getElementById('siti-link-arrow-template');
  if (!template || document.documentElement.dataset.sitiLinkArrows === 'ready') return;
  document.documentElement.dataset.sitiLinkArrows = 'ready';
  const directions = { '→': 'right', '←': 'left', '↓': 'down', '↑': 'up', '↗': 'external' };
  const arrowOnly = /^[\s\u00a0]*([→←↓↑↗])[\s\u00a0]*$/;
  const trailing = /([→↓↑↗])[\s\u00a0]*$/;
  const leading = /^[\s\u00a0]*(←)/;
  const excluded = 'form,svg,script,style,template,[data-siti-arrow-row],.siti-arrow-slot';
  function enhance(link) {
    if (link.closest('form') || !/[→←↓↑↗]/.test(link.textContent)) return;
    const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement.closest(excluded) && (trailing.test(node.nodeValue) || leading.test(node.nodeValue))) nodes.push(node);
    }
    for (const node of nodes) {
      if (!node.isConnected) continue;
      const text = node.nodeValue, match = text.match(arrowOnly) || text.match(trailing) || text.match(leading);
      if (!match) continue;
      const glyph = match[1], prefix = glyph === '←', icon = template.content.firstElementChild.cloneNode(true);
      let marker = node, container = node.parentElement;
      if (arrowOnly.test(text) && container !== link && arrowOnly.test(container.textContent) && !container.querySelector('svg')) {
        marker = container; container = marker.parentElement;
      }
      const simple = !container.querySelector('img,p,div,h1,h2,h3,h4,h5,h6,figure,dl,ul,ol') && getComputedStyle(container).display !== 'grid';
      if (!simple) {
        const slot = marker.nodeType === Node.ELEMENT_NODE ? marker : document.createElement('span');
        slot.classList.add('siti-arrow-slot');slot.dataset.sitiArrowDirection = directions[glyph];slot.setAttribute('aria-hidden','true');
        slot.replaceChildren(icon);
        if (marker.nodeType !== Node.ELEMENT_NODE) marker.replaceWith(slot);
        continue;
      }
      if (marker.nodeType === Node.ELEMENT_NODE || arrowOnly.test(text)) marker.remove();
      else node.nodeValue = prefix ? text.replace(leading,'').trimStart() : text.replace(trailing,'').trimEnd();
      const label = document.createElement('span');label.className = 'siti-arrow-label';
      while (container.firstChild) label.appendChild(container.firstChild);
      // Whitespace around a glyph used to be collapsed inconsistently in flex links.
      if (label.firstChild?.nodeType === Node.TEXT_NODE) label.firstChild.nodeValue = label.firstChild.nodeValue.trimStart();
      if (label.lastChild?.nodeType === Node.TEXT_NODE) label.lastChild.nodeValue = label.lastChild.nodeValue.trimEnd();
      if (getComputedStyle(container).justifyContent === 'center') container.dataset.sitiArrowAlign = 'center';
      container.classList.add('siti-arrow-row');container.dataset.sitiArrowRow = '';container.dataset.sitiArrowDirection = directions[glyph];
      if (prefix) container.append(icon,label);else container.append(label,icon);
    }
  }
  function scan(scope) {
    if (scope.nodeType !== Node.ELEMENT_NODE && scope.nodeType !== Node.DOCUMENT_NODE) return;
    if (scope.matches?.('a')) enhance(scope);
    scope.querySelectorAll('a').forEach(enhance);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  const pending = new Set();let scheduled = false;
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE || node.matches('.siti-link-arrow,.siti-arrow-label') || node.closest('[data-siti-arrow-row],.siti-arrow-slot')) continue;
      if (/[→←↓↑↗]/.test(node.textContent)) pending.add(node);
    }
    if (!pending.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {const scopes = [...pending];pending.clear();scheduled = false;scopes.forEach(scan);});
  });
  observer.observe(document.body,{childList:true,subtree:true});
})();
